// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnRl .colorBai ul li,.btnRl .el-checkbox__label{font-size:14px;color:#080707}.btnRl .el-input__inner{padding:0;margin:-2px 15px 0 0!important}", ""]);
// Exports
module.exports = exports;
